function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M69.6162 45.8763C69.5763 45.8763 69.5318 45.8657 69.4932 45.8662C67.9872 45.8837 67.6889 45.7066 66.3625 44.7019C63.5546 42.5746 60.5993 40.6262 58.0418 38.1891C54.8357 35.1344 52.0482 31.6755 49.46 28.0996C47.465 25.3412 45.5451 22.4259 44.7506 19.1311C44.2235 16.9492 43.8277 15.0394 43.1052 12.9205C42.3285 10.6425 41.8379 8.27076 41.6501 5.87773C41.6005 5.24845 41.5398 4.54751 41.068 4.12227C40.5468 3.65814 39.751 3.72193 39.0748 3.88503C37.7927 4.19429 36.5755 4.75757 35.5157 5.53183C35.0546 5.86924 34.6073 6.25311 34.059 6.41803C32.7631 6.80939 31.48 5.88063 30.2481 5.29831C27.5364 4.01488 24.1711 4.30339 21.7327 2.55432C21.1707 2.1512 20.2115 1.07525 19.4486 1.13041C18.3915 1.20439 18.6192 2.221 18.4433 3.12766C18.0287 5.26932 17.2629 7.32506 16.2633 9.26033C14.3444 12.9718 11.6122 16.1921 8.8696 19.3206C6.99961 21.4533 5.28261 23.8521 4.71685 26.6298C4.57794 27.3162 4.42867 28.1897 3.9593 28.7459C3.8398 28.8848 3.7258 28.9733 3.61254 29.0417C6.48877 31.2856 9.90375 32.8084 13.2607 34.2918C18.3855 36.5573 23.5109 38.8215 28.6357 41.087C31.9242 42.5384 35.2895 43.8104 38.699 44.9467C41.8429 45.9936 44.7502 47.3456 47.9298 48.3295C51.5895 49.4613 55.2146 50.6641 58.9686 51.3269C62.3403 51.922 65.6305 52.4259 69.0253 52.8535C68.2037 50.6173 68.5962 48.0898 69.6162 45.8763Z",
  fill: "#A7D2FC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M81.4023 55.2316C81.3576 54.3295 81.0904 53.4476 80.6621 52.6059C77.2142 53.5143 73.5199 53.4117 69.9492 52.9804C66.2177 52.5298 62.6488 51.9765 58.9697 51.3263C55.2158 50.6634 51.5901 49.462 47.9309 48.3288C44.7508 47.3462 41.8435 45.9942 38.6996 44.9473C35.2888 43.8104 31.9236 42.5385 28.6356 41.0858C23.5102 38.8216 18.3854 36.5561 13.26 34.2919C9.90307 32.8085 6.48937 31.2862 3.61186 29.0418C3.32057 29.2181 3.02393 29.2389 2.62851 29.4757C2.39741 29.6164 2.26819 29.8712 2.15395 30.1145C1.54172 31.4255 1.0567 32.7951 0.705968 34.1983C0.614302 34.5617 0.532837 34.9439 0.621926 35.31C0.743791 35.8149 1.16593 36.1909 1.58135 36.5102C3.40751 37.9148 5.51133 38.9052 7.59759 39.8842C10.7804 41.3778 14.0893 43.0099 17.4013 44.3481C21.9516 46.1864 26.6164 47.5974 31.1557 49.4853C36.0483 51.5199 40.9383 53.5535 45.8279 55.5883C50.7103 57.6188 55.7408 59.2633 60.9638 60.0224C64.1832 60.489 67.4204 60.9043 70.6723 61.0113C72.3238 61.0657 73.9785 61.0424 75.6213 60.9018C77.7254 60.7205 80.2874 61.2671 81.0294 58.8263C81.379 57.6681 81.4605 56.4415 81.4023 55.2316Z",
  fill: "#5D79C2"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.7678 52.7976L68.7551 52.7924C61.4652 49.5309 53.9256 46.1585 47.3934 41.3128C46.0433 40.3118 44.3118 38.9438 42.8883 37.2367C41.867 36.0101 41.0556 34.6737 40.3988 33.5296C35.6331 25.2442 32.8275 15.9276 32.2834 6.58214C32.2729 6.39528 32.4178 6.23738 32.6067 6.22723C32.7961 6.21582 32.9577 6.3613 32.9677 6.54942C33.5027 15.7889 36.2787 25.003 40.9911 33.1968C41.6354 34.3169 42.4275 35.6207 43.4138 36.8054C44.7901 38.457 46.4815 39.7927 47.7995 40.7706C54.2727 45.5721 61.7771 48.9288 69.0337 52.1741C69.2054 52.2505 69.2836 52.4529 69.2073 52.6239C69.1331 52.7898 68.9383 52.8662 68.7678 52.7976Z",
  fill: "#66AAFF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.6623 52.6063C78.7413 48.8271 73.4893 45.8938 69.6162 45.8756C68.5962 48.089 68.2031 50.6178 69.0248 52.854C69.3357 52.893 69.6366 52.9426 69.948 52.9803C73.5201 53.4121 77.2148 53.5134 80.6623 52.6063Z",
  fill: "#66AAFF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.2621 32.5102C7.13363 32.4584 7.04496 32.3336 7.04725 32.1884C7.13228 26.4087 10.6629 21.3343 14.1038 17.1326C14.5582 16.5806 15.0163 16.0302 15.475 15.4785C18.5662 11.7671 21.7613 7.92964 23.1629 3.34794C23.2175 3.1683 23.4073 3.06791 23.5884 3.12477C23.7906 3.1989 23.8722 3.37059 23.8181 3.54898C22.3773 8.261 19.1375 12.1507 16.0053 15.9127C15.5459 16.4626 15.0882 17.0118 14.6386 17.5628C11.2693 21.675 7.8132 26.6304 7.73011 32.2033C7.7284 32.3911 7.5723 32.5401 7.38392 32.5344C7.34095 32.5346 7.29899 32.525 7.2621 32.5102Z",
  fill: "#66AAFF"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.0622 18.6575C22.3008 17.5454 19.1586 18.8619 18.0594 21.5913C16.9597 24.3221 18.3131 27.4475 21.0745 28.5596C23.8372 29.6721 26.9777 28.3565 28.0774 25.6257C29.1766 22.8962 27.8249 19.7701 25.0622 18.6575ZM20.8214 29.1882C17.7089 27.9348 16.1853 24.4135 17.4247 21.3358C18.6636 18.2593 22.2029 16.7755 25.3154 18.0289C28.4279 19.2823 29.9523 22.8054 28.7134 25.8819C27.474 28.9596 23.9339 30.4417 20.8214 29.1882Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.4425 20.5886L24.5256 23.203L26.756 24.8961L23.9566 24.8178L23.0398 27.4323L22.2284 24.7706L19.4308 24.6916L21.7276 23.1253L20.9154 20.4619L23.1465 22.1567L25.4425 20.5886Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7637 12.6439C36.302 12.4579 35.957 12.0297 35.9061 11.5066C35.8329 10.7597 36.3849 10.1009 37.1363 10.0338C39.2956 9.84406 43.313 9.84152 45.9333 11.9648C46.5211 12.4397 46.6128 13.2949 46.1386 13.874C45.664 14.4543 44.8038 14.5419 44.2132 14.0629C42.2775 12.4973 38.8035 12.6149 37.4012 12.7384C37.1775 12.7579 36.9596 12.7228 36.7637 12.6439Z",
  fill: "#5D79C2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.0293 46.7253C61.9975 46.7125 61.9675 46.6989 61.9367 46.6836C61.2574 46.3516 60.9733 45.5373 61.3032 44.865C61.6921 44.0719 61.9832 43.235 62.1714 42.3786C62.2123 42.189 62.223 42.0779 62.2247 42.0187C61.8198 41.4641 61.8894 40.6855 62.4101 40.2187C62.969 39.7191 63.8362 39.7644 64.3441 40.324C65.2197 41.2844 64.9402 42.5585 64.8458 42.9764C64.614 44.0402 64.2494 45.0813 63.7661 46.0687C63.4514 46.7106 62.6895 46.9911 62.0293 46.7253Z",
  fill: "#5D79C2"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.3749 42.6041C55.02 42.4612 54.7244 42.1712 54.5893 41.7836C54.3399 41.0739 54.7167 40.3036 55.4303 40.0621C56.6489 39.6498 57.7302 38.7892 58.3994 37.6999C58.7911 37.0613 59.6216 36.8566 60.2804 37.2578C60.9258 37.6521 61.1326 38.4894 60.7415 39.1267C59.7319 40.7672 58.1678 42.012 56.3321 42.6316C56.0087 42.7409 55.67 42.7229 55.3749 42.6041Z",
  fill: "#5D79C2"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.1176 39.3517C49.9116 39.2687 49.7227 39.1357 49.5714 38.9535C49.0887 38.3719 49.1683 37.517 49.7509 37.043C51.3879 35.7092 53.2014 34.5941 55.1353 33.7306C55.8262 33.4244 56.6377 33.7293 56.9506 34.4134C57.2664 35.0973 56.9638 35.9003 56.2784 36.2073C54.5596 36.9734 52.9516 37.9637 51.4995 39.1469C51.0994 39.4724 50.5679 39.533 50.1176 39.3517Z",
  fill: "#5D79C2"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.9746 35.229C45.7367 35.1332 45.5226 34.971 45.3646 34.7467C44.9276 34.1323 45.0736 33.2852 45.6909 32.8573C47.5816 31.5468 49.6032 30.3884 51.6966 29.4152C52.3799 29.0987 53.196 29.3922 53.5207 30.0724C53.846 30.7513 53.5578 31.5587 52.874 31.8765C50.9211 32.7836 49.0359 33.8639 47.2734 35.0872C46.8785 35.3593 46.3905 35.3965 45.9746 35.229Z",
  fill: "#5D79C2"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.5516 29.8603C42.1814 29.7112 41.8789 29.4053 41.7513 28.9989C41.5241 28.282 41.9245 27.5227 42.6469 27.3037C45.0318 26.5794 47.4788 25.943 49.9161 25.4079C50.6556 25.2454 51.3868 25.7094 51.5558 26.4423C51.7254 27.1739 51.2637 27.8983 50.5272 28.0605C48.159 28.5781 45.7836 29.1981 43.4663 29.9014C43.1533 29.996 42.8339 29.974 42.5516 29.8603Z",
  fill: "#5D79C2"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.8832 23.9482C40.48 23.7858 40.1578 23.4369 40.0546 22.9847C39.8843 22.2513 40.346 21.527 41.0825 21.3647C42.961 20.9509 44.9003 21.0466 46.6101 21.1287L48.5616 21.2235C49.3139 21.2606 49.9051 21.8961 49.8753 22.6453C49.8443 23.3941 49.2079 23.9721 48.4513 23.9348L46.498 23.8408C44.8843 23.7622 43.217 23.6811 41.694 24.0161C41.415 24.0776 41.1325 24.0486 40.8832 23.9482Z",
  fill: "#5D79C2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.0682 18.6183C38.665 18.4559 38.3433 18.1058 38.2388 17.6531C38.0693 16.9215 38.531 16.1971 39.2675 16.0349C41.9465 15.4466 44.7393 15.607 47.34 16.4979C48.0377 16.7292 48.4415 17.5143 48.2001 18.2236C47.9588 18.933 47.181 19.308 46.465 19.0635C44.3736 18.3469 42.0343 18.2128 39.879 18.6862C39.5987 18.7472 39.3175 18.7187 39.0682 18.6183Z",
  fill: "#5D79C2"
});

var SvgBannerShoe1 = function SvgBannerShoe1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 87,
    height: 62,
    viewBox: "0 0 87 62",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBannerShoe1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/banner-shoe-1.085b7de9.svg";
export { ForwardRef as ReactComponent };